import { Alert, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useProductsPercentage } from '../../../hooks/useProductsPercentage'
import { messages } from './messages'
import { styles } from './styles'
import { useTrack } from 'hooks'
import { Event } from 'typings'

export const SCOPE_ALERT_THRESHOLD = 80

export function AffectedProductsAlert() {
  const { percentage, formattedPercentage, loading } = useProductsPercentage()

  useTrack({
    event: Event.PRODUCT_PERCENTAGE_ALERT_VIEW,
    payload: { threshold: SCOPE_ALERT_THRESHOLD, value: percentage },
    enable:
      !loading &&
      percentage !== undefined &&
      (percentage === 0 || percentage >= SCOPE_ALERT_THRESHOLD),
  })

  if (loading || percentage === undefined) return null

  if (percentage === 0) {
    return (
      <Alert role="alert" variant="critical" className={styles.container}>
        <FormattedMessage {...messages.zeroProductsPercentage} />
      </Alert>
    )
  }

  if (percentage < SCOPE_ALERT_THRESHOLD) return null

  return (
    <Alert role="alert" variant="warning" className={styles.container}>
      <FormattedMessage
        {...messages.highProductsPercentage}
        values={{
          percentage: formattedPercentage,
          b: (content) => <Text variant="action1">{content}</Text>,
        }}
      />
    </Alert>
  )
}
